import { accountAPI } from "services";

export const defaultValues = {
  name: "",
  phone: "",
  address: "",
  details: "",
  photo: { url: null, loading: false, file: null },
  tag: null
};

export const validateAccountName = async (value, accountId = null) => {
  if (!value) return "Name is required";

  if (accountId) {
    // For EditAccount - check if name changed
    const currentAccount = await accountAPI.getAccountById(accountId);
    if (currentAccount?.get("name") === value) return true;
  }

  // Check if name exists
  const accountByName = await accountAPI.getAccountByName(value);
  return !accountByName || "Account with this name already exists";
};
